import * as React from 'react';
import { Container, Box, Alert, SpaceBetween } from "@amzn/awsui-components-react/polaris";
import { useTranslator } from '../../localization/Translator';

interface GuidanceMessagePanelProps {
  message: string | null;
}

const GuidanceMessagePanel: React.FC<GuidanceMessagePanelProps> = ({ message }) => {
  const t = useTranslator();
  if (!message) {
    return null;
  }

  return (
    <Container>
      <SpaceBetween direction="vertical" size="s">
        <Box fontSize="heading-s" fontWeight="bold">
          {t.translate("guidance_header")}
        </Box>
        <Alert type="info">
          <Box fontSize="body-m">
            {message}
          </Box>
        </Alert>
      </SpaceBetween>
    </Container>
  );
};

export default GuidanceMessagePanel;